export default ({ request }) => ({
  customerLabelsList(data) {
    return request({
      url: '/digitalCenter/masterCustomer/labels/list',
      method: 'post',
      data,
    })
  },
  customerLabelsDetail(data) {
    return request({
      url: '/digitalCenter/masterCustomer/labels/detail',
      method: 'post',
      data,
    })
  },
  customerLabelsSave(data) {
    return request({
      url: '/digitalCenter/masterCustomer/labels/save',
      method: 'post',
      data,
    })
  },
  customerLabelsDel(data) {
    return request({
      url: '/digitalCenter/masterCustomer/labels/del',
      method: 'post',
      data,
    })
  },
})
